/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import testPlaceholder from './svgs/default.svg';
import largePicturePlaceholder from './svgs/large.svg';
import smallPicturePlaceholder from './svgs/small.svg';

export const DEFAULT_PLACEHOLDER = 'large';
export const LARGE_IMAGE_PLACEHOLDER = 'large';
export const SMALL_IMAGE_PLACEHOLDER = 'small';
export const TEST_PLACEHOLDER = 'test';

export default {
    testPlaceholder,
    largePicturePlaceholder,
    smallPicturePlaceholder
};
